import { Route } from 'react-router';
import ProtectedRoutes from '../components/ProtectedRoutes';
import {
  GamesPage,
  GameInfoPage,
  GameLaunchPage as _GameLaunchPage,
  ProviderGamesPage,
  PublicGamesPage,
  RedirectPage,
  PlayWithCoinsPage,
} from '@betty/games/pages';
import DynamicRoute from './DynamicRoute';
import Config from '@betty/toolkit/config';
import { withMkodoCheck } from '@betty/mkodo';

const GameLaunchPage = Config.MKODO_ENABLED
  ? withMkodoCheck(_GameLaunchPage)
  : _GameLaunchPage;

export const renderGamesRoutes = () => (
  <>
    <Route element={<ProtectedRoutes />}>
      <Route
        path="/games/launch/:id/:currencyCode?"
        element={<GameLaunchPage />}
      />
      <Route
        path="/game-launch/:id/:currencyCode?"
        element={
          <RedirectPage
            getPath={(params) =>
              `/games/launch/${params.id}${params.currencyCode ? `/${params.currencyCode}` : ''}`
            }
          />
        }
      />
      <Route path="/play-with-coins" element={<PlayWithCoinsPage />} />
      <Route path="/games/top-slot-providers" element={<ProviderGamesPage />} />
    </Route>
    <Route
      path="games"
      element={
        <DynamicRoute
          AnonymousComponent={PublicGamesPage}
          AuthenticatedComponent={GamesPage}
        />
      }
    />
    <Route path="/games/:name" element={<GameInfoPage />} />
  </>
);
